import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { useCallback } from 'react';
import type { AufgabeLoeschenMutation, AufgabeLoeschenMutationVariables } from './__generated__/AufgabeLoeschenMutation';
export type { NeukundenObjektFragment as NeukundenObjekt } from './__generated__/NeukundenObjektErstellenMutation';

export const useAufgabeLoeschenMutation = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const [executeMutation, { loading, error }] = useMutation<AufgabeLoeschenMutation, AufgabeLoeschenMutationVariables>(gql`
    mutation aufgabeLoeschen($id: UUID!) {
      aufgabeLoeschen(id: $id) {
        erfolgreich
        fehlermeldung
        id
      }
    }
  `, {
    onError: handleWithErrorNotification('Das Erstellen des Neukunden Objekts ist fehlgeschlagen.'),
    update(cache) {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'neukundenObjektErstellen' });
    },
  });

  return {
    execute: useCallback((variables: AufgabeLoeschenMutationVariables) => executeMutation({ variables }), [executeMutation]),
    loading,
    error,
  };
};
